/**
 * Presentations chrome (PRESENT-SPEC-20261028 §7). English only: the ruling of 28 Oct 2026 keeps this module's text in English and
 * adds no Thai dictionary (chrome is English for everyone anyway, `chromeLocale`). The package's own content is never translated.
 */
const EN = {
  presentations: "Presentations",
  privateBadge: "Private",
  sharedWith: "Shared with {n}",
  sharedWithOne: "Shared with 1 person",
  sharedWithProject: "Shared with the whole project",
  share: "Share",
  shareTitle: "Share {title}",
  shareIntro: "Only you see this presentation until you share it. People you share with can open and present it; only you can change it.",
  shareWholeProject: "Whole project",
  shareWholeProjectHelp: "Everyone in this project who can see presentations (never partners).",
  sharePeople: "People",
  shareAddPerson: "Add a person",
  shareNobody: "Nobody yet.",
  shareRemove: "Remove {name}",
  shareSave: "Save",
  add: "Add",
  shareSaved: "Sharing saved.",
  ownerOnlyNote: "Shared with you by {name}. Only they can change it.",
  loading: "Loading…",
  loadFailed: "The presentations could not be loaded.",
  retry: "Try again",
  emptyTitle: "No presentations yet.",
  emptyHint: "Upload an HTML package (.zip with index.html).",
  newPresentation: "New presentation",
  showArchived: "Show archived",
  archivedBadge: "Archived",
  live: "Live",
  liveBy: "Live · {name}",
  noVersionYet: "No version ready yet",
  versionLine: "v{n} · {files} files · {size} · {when} · by {name}",
  versionLineShort: "v{n} · {files} files · {size} · {when}",
  pageCount: "{n} pages",
  pageCountOne: "1 page",
  present: "Present",
  openController: "Open the controller",
  presentPictures: "Present with pictures only",
  uploadNewVersion: "Upload new version",
  more: "More",
  rename: "Rename",
  versions: "Versions",
  archive: "Archive",
  unarchive: "Unarchive",
  archiveLive: "End the live presentation first, then archive.",
  title: "Title",
  titleRequired: "Give the presentation a title.",
  titleTooLong: "Keep the title to 200 characters.",
  save: "Save",
  cancel: "Cancel",
  close: "Close",
  // Upload dialog (§7.1)
  uploadTitleNew: "New presentation",
  uploadTitleVersion: "Upload a new version of {title}",
  chooseZip: "Package (.zip with index.html at its root)",
  zipOnly: "Choose a .zip file.",
  zipTooLarge: "This file is larger than 200 MB. Make the package smaller.",
  upload: "Upload",
  checkingFile: "Checking the file…",
  uploadingParts: "Uploading {done} of {total} parts",
  processing: "Processing…",
  savingFiles: "Saving files {done} of {total}",
  readySummary: "v{n} is ready: {pages}, {sections}, {warnings}",
  sectionsCount: "{n} sections",
  sectionsCountOne: "1 section",
  warningsCount: "{n} warnings",
  warningsCountOne: "1 warning",
  noWarnings: "no warnings",
  failedTitle: "The package was not accepted",
  failedHint: "Fix the package and upload again.",
  cancelledNote: "The upload was stopped. Nothing was saved.",
  leaveWarning: "The upload will stop",
  stopUpload: "Stop upload",
  uploadAgain: "Upload again",
  // Versions and past sessions
  versionsTitle: "Versions of {title}",
  version: "Version",
  status: "Status",
  size: "Size",
  who: "Who",
  when: "When",
  current: "Current",
  makeCurrent: "Make current",
  madeCurrent: "v{n} is now the current version.",
  noVersions: "No versions yet.",
  pastSessions: "Past sessions",
  noPastSessions: "Nobody has presented this yet.",
  presenter: "Presenter",
  started: "Started",
  duration: "Duration",
  screens: "Screens",
  endReason: "Ended",
  endReasonPresenter: "By the presenter",
  endReasonIdle: "No activity for 12 hours",
  stillLive: "Still live",
  statusUploading: "Uploading",
  statusProcessing: "Processing",
  statusReady: "Ready",
  statusFailed: "Failed",
  statusCancelled: "Cancelled",
  // Starting a session
  sessionLiveTitle: "Already being presented",
  sessionLiveOther: "{name} is presenting this now (since {when}). Ask them to end it before you start.",
  sessionLiveMine: "You are already presenting this (since {when}), maybe in another window.",
  takeOver: "Take over control",
  takeOverHint: "This window becomes the controller. The other window stops controlling; the screens stay connected.",
  // Controller (§7.2)
  controllerTitle: "Controller",
  timerElapsed: "Since start",
  stopwatch: "Stopwatch",
  pause: "Pause",
  resume: "Resume",
  reset: "Reset",
  target: "Target (minutes)",
  screensNone: "No screens",
  screensSummary: "{n} screens · {on}",
  screensSummaryOne: "1 screen · {on}",
  allOnPage: "all on page",
  someOnPage: "{n} on page",
  bothOnPage: "both on page",
  onPageOne: "on page",
  notOnPage: "not on page yet",
  addScreen: "Add screen",
  displayLabel: "Display",
  displayLive: "Live",
  displayPictures: "Pictures",
  endPresentation: "End presentation",
  endConfirmTitle: "End for every screen?",
  endConfirmBody: "Every screen shows \"Presentation ended\" and then a new code.",
  endConfirm: "End presentation",
  currentPage: "Current page — audience sees this",
  currentPagePresenterOnly: "Current page — presenter only",
  audienceStillSees: "Audience still sees: {title}",
  next: "Next",
  previous: "Previous",
  nextUp: "Next",
  endOfDeck: "End of the presentation",
  notes: "Notes",
  noNotes: "No notes for this page.",
  stepsOf: "Steps {step} of {total}",
  pageOf: "Page {n} of {total}",
  pageList: "Pages",
  searchPages: "Find a page",
  presenterOnly: "Presenter only",
  firstPageConfirm: "Go back to the first page?",
  goToFirst: "Go to the first page",
  reconnecting: "Reconnecting…",
  lostControl: "Control moved to another window. This window no longer controls the presentation.",
  ended: "This presentation has ended.",
  backToList: "Back to presentations",
  pictureOnlyNote: "Pictures only: the package does not run.",
  noPicture: "No picture for this page.",
  stoppedAtStep: "Audience stopped at step {step}. Press Next to move on.",
  previewStoppedAtStep: "The preview stopped at step {step}. Press Next to move on.",
  packageError: "The package says: {message}",
  dismiss: "Dismiss",
  screenOnline: "Online",
  screenOffline: "Offline",
  screenRejoining: "Reconnecting…",
  screenRejoiningHint: "This screen lost its connection and comes back by itself on the current page. Drop removes it for good.",
  screenOnPage: "Shows the current page",
  screenLatency: "Shown {ms} ms after the click",
  drop: "Drop",
  dropFailed: "The screen could not be dropped.",
  // Add screen
  addScreenTitle: "Add a screen",
  addScreenHint: "Type the 6-digit code shown on the audience screen.",
  codeDigit: "Digit {n} of 6",
  pair: "Add",
  pairing: "Adding…",
  paired: "{name}'s screen is connected.",
  codeInvalid: "That code is not valid. Check the code on the screen and try again.",
  pairLocked: "Too many wrong codes. Try again in {minutes} minutes.",
  pairLockedSoon: "Too many wrong codes. Try again shortly.",
  screenNotAllowed: "The account signed in on that screen cannot see this presentation.",
  screenCapReached: "This presentation already has {n} screens. Drop one first.",
  noControlKey: "This window is not the controller of this presentation.",
  // Audience (§7.3)
  audienceTitle: "Presentation screen",
  typeThisCode: "Type this code on the presenter's controller",
  codeExpiresIn: "New code in {time}",
  signedInAs: "Signed in as {name}",
  connectedTo: "Connected to {title}. Waiting for the presenter…",
  fullScreen: "Full screen",
  mainView: "Main view",
  mapButton: "Map",
  stepPanel: "Steps on this screen",
  openFrom: "Open from:",
  stepDone: "done",
  byHand: "by hand",
  resultOnScreen: "Result on screen",
  stepN: "Step {n}",
  pointerOn: "Pointer on",
  pointerOff: "Pointer off",
  roomShowsLive: "Room shows: Live",
  roomShowsPictures: "Room shows: Pictures",
  tabsLabel: "Sections of the deck",
  paused: "paused",
  moreMenu: "More",
  roomInSync: "in sync",
  roomKeeps: "the room still shows {title} (presenter-only page)",
  roomApp: "the app is open on the room's screens",
  roomPictures: "the room shows pictures only",
  roomShows: "Room shows:",
  nextStep: "Next: Step {step} of {total}",
  nextStepNoLabel: "The next step of this screen",
  sectionsLabel: "Sections",
  filmstripLabel: "Page strip",
  goToPage: "Go to page",
  resetLayout: "Reset layout",
  openApp: "Open {label}",
  backToSlide: "Back to the slide",
  projectorShort: "Projector",
  screensCount: "{n} screens",
  splitFilm: "Resize the page strip",
  splitNextNotes: "Resize notes and Next",
  splitPages: "Resize the page list",
  splitSide: "Resize the right column",
  splitAudience: "Resize Audience sees and Next",
  splitNext: "Resize Next and Notes",
  splitNotes: "Resize Notes and Screens",
  viewHandwriting: "Handwriting",
  viewOriginal: "Original",
  audienceSeesInset: "Audience sees",
  handwritingInset: "Handwriting",
  currentPageHandwriting: "Current page — your handwriting",
  fullScreenHint: "Click or press F for full screen",
  putOnProjector: "Put on projector",
  projectorJoining: "Projector window: joining the presentation…",
  projectorWindow: "Projector window",
  openProjector: "Open projector window",
  projectorClosed: "Projector window closed.",
  reopenProjector: "Reopen",
  projectorBlocked: "The browser blocked the projector window. Allow pop-ups for this site, or open it here:",
  projectorOpenHere: "Open the projector window",
  presentationEnded: "Presentation ended",
  screenRemoved: "This screen was removed by the presenter",
  leave: "Leave",
  newCodeSoon: "A new code appears in a moment.",
  notAvailable: "Presentations are not available.",
  phoneTitle: "Current page",
  openPages: "Pages",
  // Rulings of 29 Oct 2026: behaviour (clicker, pointer, projector window, audience screen button)
  clickerReady: "Clicker: ready",
  clickerNotWorking: "Clicker not working: click here once",
  clickerHint: "Keys from a presenter clicker reach this window. If they stop, click here once.",
  pointer: "Pointer",
  pointerHint: "Laser pointer (L). The mouse over the slide shows a red dot on every screen.",
  laserOn: "Laser on — Esc",
  projectorDiverged: "Projector changed by hand",
  screensDiverged: "Changed by hand: {names}",
  screensFull: "{n} screens is the most. Drop one to add another.",
  resync: "Resync",
  resyncHint: "Put the projector window back on the audience page. Next, Previous or any jump also does it.",
  allowClicks: "Allow clicks",
  allowClicksHint: "Let this laptop click inside the package (map, tables, menus). Its clicks stay on that laptop.",
  whyReconnecting: "Reconnecting…",
  whyLastPage: "Last page",
  whyFirstPage: "First page",
  whyLoading: "Loading…",
  whyNoControl: "Not in control",
  whyEnded: "Ended",
  openAudienceScreen: "Open audience screen",
  openAudienceScreenHint: "On the audience laptop: Open audience screen, then type its code on your controller.",
  evsimNote: "EVSIM is opened by hand on the presentation laptop.",
} as const;

export type PresentTextKey = keyof typeof EN;

export function presentText(key: PresentTextKey, values: Record<string, string | number> = {}): string {
  return EN[key].replace(/\{(\w+)\}/g, (match, name: string) => (name in values ? String(values[name]) : match));
}
